import { Accordion, Button, Flex, LoadingIndicator, ModalV2, Text } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import type { FormulaListItem } from "~/graphql/supergraphTypes";

export type FormulasInUseWarningModalProps = {
  show: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  isSubmitting: boolean;
  formulas: Pick<FormulaListItem, "id" | "name" | "description" | "expression">[] | null;
  isLoading: boolean;
};

export const FormulasInUseWarningModal = ({
  show,
  onCancel,
  onConfirm,
  isSubmitting,
  formulas,
  isLoading,
}: FormulasInUseWarningModalProps) => (
  <ModalV2
    show={show}
    onHide={onCancel}
    title="Hierarchy in use"
    size="medium"
    isCentered
    data-testid="warning-modal"
  >
    <ModalV2.Body>
      <Flex flexDirection="column" gap={SPACING.MEDIUM}>
        <Text variant="secondary-md">
          This hierarchy is currently in-use. Are you sure you want to make this update? This
          might break your templates. Please validate your templates post-update.
        </Text>
        {isLoading ? (
          <LoadingIndicator />
        ) : (
          formulas &&
          formulas.length > 0 && (
            <Accordion title="Formulas impacted" startExpanded={true}>
              <Flex flexDirection="column" gap={SPACING.MEDIUM}>
                {formulas.map((formula) => (
                  <Flex key={formula.id} flexDirection="column" gap={SPACING.X_SMALL}>
                    <Flex gap={SPACING.X_SMALL} alignItems="center">
                      <Text variant="secondary-sm">ID:</Text>
                      <Text variant="regular-sm">{formula.id}</Text>
                    </Flex>
                    <Flex gap={SPACING.X_SMALL} alignItems="center">
                      <Text variant="secondary-sm">Name:</Text>
                      <Text variant="regular-md">{formula.name}</Text>
                    </Flex>
                    {formula.description && (
                      <Flex gap={SPACING.X_SMALL}>
                        <Text variant="secondary-sm">Description:</Text>
                        <Text variant="regular-sm">{formula.description}</Text>
                      </Flex>
                    )}
                    <Flex flexDirection="column" gap={SPACING.X_SMALL}>
                      <Text variant="secondary-sm">Expression:</Text>
                      <Text variant="regular-sm">{formula.expression}</Text>
                    </Flex>
                  </Flex>
                ))}
              </Flex>
            </Accordion>
          )
        )}
      </Flex>
    </ModalV2.Body>
    <ModalV2.Footer>
      <Flex justifyContent="flex-end" gap={SPACING.MEDIUM}>
        <Button variant="neutral" onClick={onCancel} data-testid="cancel-warning-btn">
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={onConfirm}
          isLoading={isSubmitting}
          data-testid="confirm-update-btn"
        >
          Confirm update
        </Button>
      </Flex>
    </ModalV2.Footer>
  </ModalV2>
);
